import React from 'react';
import { Button, CardBody, Card, Row, Col,
    Form,
    FormGroup,Label,
    Input,
    Container, Table
     } from 'reactstrap';
     import { Link } from 'react-router-dom';

const DocumentType = () => {
    return (
        <div className='AttendanceRules'>
           <Container>
           <Row>
                <Col xs="12" md="12" sm="12">
                <Card>

                        <CardBody className="">
                        

            <Link  style={{ color:'#121127',marginBottom:'10px!important'}} to="/payroll-new/settings" className='text-nowrap'>
            <i className="fa fa-arrow-circle-left" style={{color:'#72B566', fontSize:'16px'}} aria-hidden="true"></i> Back to settings management </Link>

        <Form className="form" style={{marginTop:'60px'}}>
                   
                   <Row>

                   <Col className='col-md'>
                    
                        <FormGroup>
                    <Label htmlFor="description">Document Type</Label>
                    <div className="d-flex no-wrap">
                    <Input 
                        type="text"
                        name="DocumentType"
                        id="DocumentType"
                        placeholder="Type here"
                        /><i className="fa fa-trash" aria-hidden="true" style={{color:'#FC6666', fontSize:'13px', padding:'10px 0px 0px 4px'}}></i>
                    </div>
                   
                    </FormGroup>
                        
                        </Col>


                   
                    <Col className='col-md'>
                    
                    <FormGroup>
                            <Label htmlFor="amount">ID Document</Label>
                            <div className="d-flex no-wrap">
                            <Input
                        type="text"
                        name="Iddocument"
                        id="Iddocument"
                        placeholder="Type here"
                        /><i className="fa fa-trash" aria-hidden="true" style={{color:'#FC6666', fontSize:'13px', padding:'10px 0px 0px 4px'}}></i>
                        </div>
                            </FormGroup>
                    </Col>
                   
                   </Row>

                   <Row>

                   <Col className='col-md'>
                    <FormGroup>
                            <Label htmlFor="amountType">Passport</Label>
                            <div className="d-flex no-wrap">
                            <Input
                        type="text"
                        name="Passport"
                        id="Passport"
                        placeholder="Type here"
                        /><i className="fa fa-trash" aria-hidden="true" style={{color:'#FC6666', fontSize:'13px', padding:'10px 0px 0px 4px'}}></i></div>
                            </FormGroup>
                    
                    </Col>

                    <Col className='col-md'>
                    <FormGroup>
                            <Label htmlFor="Foreigner">Driving Licence</Label>
                            <div className="d-flex no-wrap">
                            <Input
                        type="text"
                        name="Drivinglicence"
                        id="Drivinglicence"
                        placeholder="Type here"
                        /><i className="fa fa-trash" aria-hidden="true" style={{color:'#FC6666', fontSize:'13px', padding:'10px 0px 0px 4px'}}></i></div>
                            </FormGroup>
                    
                    </Col>



                   </Row>



                   <hr/>
                  <Button
                        color="success"
                        className="bt float-left " type="add"
                                ><i className="fa fa-plus" aria-hidden="true"></i> Add another item
                  </Button>
                        </Form>             

                       






                       



 
                    

                        </CardBody>
                        </Card>
                </Col>
                
            </Row>
            


           </Container>
            
        </div>
    );
}

export default DocumentType;
